import { useBoolean } from 'usehooks-ts';

import { DefaultDataTableCell as DefaultCellView } from '../presets';
import { ColumnDef, DataTableBlurHandler } from '../types';

type Props<TData> = {
  item: TData;
  column: ColumnDef<TData>;
  rowKey: string;
  onBlur: DataTableBlurHandler<TData>;
};

const BodyCell = <TData extends Record<string, unknown>>({
  column,
  item,
  rowKey,
  onBlur,
}: Props<TData>) => {
  const { cell, cellEdit: Edit, key } = column;

  const isEditable = !!Edit;

  const {
    value: isEditModeOn,
    setTrue: setEditModeOn,
    setFalse: setEditModeOff,
  } = useBoolean(false);

  if (isEditable && isEditModeOn) {
    return (
      <Edit
        columnKey={key}
        initialData={item}
        rowKey={rowKey}
        onBlur={newValue => {
          setEditModeOff();
          onBlur(newValue);
        }}
      />
    );
  }

  const View = cell || DefaultCellView;

  return (
    <View
      columnKey={key}
      data={item}
      rowKey={rowKey}
      onToggleEdit={isEditable ? setEditModeOn : undefined}
    />
  );
};

export default BodyCell;
